<div [@collapse]="state.animState" [class.completed]="state.completed" class="task-container">
  <div
    [class.rt-card-clickable]="isEditable"
    [class.has-second-line]="
      task.dueDate || task.description || (editableCandidate && task.candidate)
    "
    [class.background]="state.completed"
    class="rt-card"
    padding-medium
  >
    <div class="entry">
      <rt-checkbox
        [checked]="state.completed"
        [disabled]="state.loading || !isEditable"
        (valueChange)="toggle()"
        class="selector"
      >
      </rt-checkbox>
      <div #taskTitle class="title" [innerHtml]="state.title"></div>
    </div>
    <div class="meta" layout-horizontal layout-space-between>
      <div class="candidate" layout-horizontal layout-align-items-center>
        @if (task.dueDate) {
          <span
            [ngClass]="state.dateClass!"
            [rtTooltip]="dueDate | amDateFormat: dueDateTooltipFormat"
            [rtTooltipPosition]="'above'"
            layout-horizontal
            layout-align-items-center
            margin-right-small-x
          >
            <rt-icon name="access-time" size="small-x" margin-right-small-x> </rt-icon>
            <span ngPreserveWhitespaces class="time-date-wrap">
              <span class="humanized-date-wrap">{{ state.humanizedDate }}</span
              >,
              <span class="time-wrap">{{ dueDate | amDateFormat: 'LT' }}</span>
            </span>
          </span>
        }
        @if (editableCandidate && task.candidate) {
          <div layout-horizontal layout-align-items-center margin-right-small overflow-hidden>
            <rt-icon name="person" size="small-x" margin-right-small-x> </rt-icon>
            <span
              (click)="goToCandidate($event, task.candidate.id)"
              overflow-hidden
              class="candidate-name"
            >
              <rt-truncate>{{ task.candidate.name }}</rt-truncate>
            </span>
          </div>
        }
        @if (task.description) {
          <rt-icon
            name="message"
            size="small-x"
            [rtTooltip]="'app.tasks.note_tooltip' | translate"
            [rtTooltipPosition]="'above'"
          >
          </rt-icon>
        }
      </div>
      @if (task.admins) {
        <rt-admins-avatars
          [admins]="$any(task.admins)"
          [stacked]="true"
          [limit]="3"
          margin-left-auto
          variant="ltr"
        >
        </rt-admins-avatars>
      }
      @if (task.triggered) {
        <rt-icon
          [rtTooltip]="'app.automated_actions.automated_actions' | translate"
          name="automated-actions"
          size="small"
          [attr.margin-left-auto]="!task.admins ? '' : null"
          margin-left-small-x
        >
        </rt-icon>
      }
      <rt-date [tiny]="true" [time]="task.createdAt" tooltipPosition="left" variant="small">
      </rt-date>
    </div>
  </div>
</div>
